<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link
        class="brand-logo"
        style="display:flex"
      >
        <logo class="d-none d-lg-block" />

      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            {{ $t('Welcome_to',{brand_name:getBrandName()}) }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('login_page_description') }}
          </b-card-text>
          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
            >
              <!-- pin -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t('code') }}</label>
                </div>
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('code')"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="code"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="login-password"
                      :placeholder="$t('code')"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-card-text class="text-center mt-2">
                <div class="countdown">
                  <flip-countdown
                    :deadline="deadline"
                    :show-days="false"
                    :show-hours="false"
                    @timeElapsed="timeElapsedHandler"
                  />
                </div>
                <b-button
                  v-if="!pendingResend"
                  type="submit"
                  variant="outline-primary"
                  block
                  :disabled="disable"
                  class="resend"
                  @click.stop.prevent="resend"
                >
                  {{ $t('resend') }}
                </b-button>
                <b-button
                  v-if="pendingResend"
                  variant="outline-primary"
                  block
                  disabled
                  class="resend"
                >
                  <b-spinner
                    small
                    type="grow"
                  />
                </b-button>
              </b-card-text>
              <!-- submit buttons -->
              <b-button
                v-if="!pending"
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
                @click.stop.prevent="submit"
              >
                {{ $t('sign_in') }}
              </b-button>
              <b-button
                v-if="pending"
                variant="primary"
                block
                disabled
              >
                <b-spinner
                  small
                  type="grow"
                />
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Logo from '@/views/theme2/components/logo.vue'
import LoginSection2 from '@/views/logics/auth/LoginSection2'

export default {

  components: {
    Logo,
  },
  mixins: [togglePasswordVisibility, LoginSection2],
}
</script>

<style lang="scss">
    @import '@core/scss/vue/pages/page-auth.scss';
    .auth-login-form
    {
     .card-text
     {
       position: relative;
       width: 100%;
       display: inline-block;
     }
      .btn-outline-primary
      {
        width: 100%;
        margin: 20px 0 0;
      }
    }

</style>
